import { MenuItem } from "@mui/material";
import React, { useEffect } from "react";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import classes from "./Mapa.module.scss";

export default function SearchBox({ onSetCoordenadas, direccion }) {
    const {
        ready,
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: { country: "ar" },
        },
        debounce: 300,
    });

    useEffect(() => {
        if (direccion) {
            setValue(direccion);
        }
    }, [direccion, setValue]);

    const handleInput = (e) => {
        setValue(e.target.value);
    };

    const handleSelect =
        ({ description }) =>
            async () => {
                setValue(description, false);
                clearSuggestions();

                const results = await getGeocode({ address: description });
                const addressComponents = results[0].address_components;

                const streetName = addressComponents.find((c) =>
                    c.types.includes("route")
                )?.long_name;
                const streetNumber = addressComponents.find((c) =>
                    c.types.includes("street_number")
                )?.long_name;
                const postalCode = addressComponents.find((c) =>
                    c.types.includes("postal_code")
                )?.long_name;

                const city =
                    addressComponents.find((c) => c.types.includes("locality"))
                        ?.long_name ||
                    addressComponents.find((c) =>
                        c.types.includes("administrative_area_level_2")
                    )?.long_name ||
                    addressComponents.find((c) => c.types.includes("sublocality"))
                        ?.long_name;

                onSetCoordenadas({
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng(),
                    calle: streetName || "",
                    numero: streetNumber || "",
                    localidad: city || "",
                    cod: postalCode || "",
                });
            };

    const renderSuggestions = () =>
        data.map((suggestion, index) => {
            const {
                place_id,
                structured_formatting: { main_text, secondary_text },
            } = suggestion;
            if (index < 3) {
                return (
                    <MenuItem
                        key={place_id}
                        onClick={handleSelect(suggestion)}
                        style={{ fontFamily: "Roboto", listStyleType: "none" }}
                    >
                        <strong>{main_text}, </strong>&nbsp;
                        <small> {secondary_text}</small>
                    </MenuItem>
                );
            }
            return null;
        });

    return (
        <div className={classes.searchBoxContainer}>
            <input
                value={value}
                onChange={handleInput}
                disabled={!ready}
                className={classes.searchBox}
                placeholder="Buscar dirección o lugar..."
            />
            {status === "OK" && (
                <ul style={{ paddingLeft: "0" }}>{renderSuggestions()}</ul>
            )}
        </div>
    );
}
